// The voice for each language: an Apple identifier that carries the locale,
// and names the voice to prefer. It is not the voice that plays — speak.js
// ranks whatever the visitor's browser has for that locale (Premium and
// Microsoft "Natural" first, then Enhanced, the standard voice, Google's
// online voices, and never the novelty ones) and uses the named voice only to
// break a tie. The same table works on Safari, Chrome, Edge and Android.
// Kept in step with the iOS app's Language.swift.
const voices = {
  eng: 'com.apple.voice.compact.en-GB.Daniel',
  nld: 'com.apple.voice.compact.nl-NL.Xander',
  spa: 'com.apple.voice.compact.es-ES.Monica',
  por: 'com.apple.voice.compact.pt-PT.Joana',
  rus: 'com.apple.voice.compact.ru-RU.Milena',
  deu: 'com.apple.voice.compact.de-DE.Anna',
  fra: 'com.apple.voice.compact.fr-CA.Amelie',
  ita: 'com.apple.voice.compact.it-IT.Alice',
  jpn: 'com.apple.voice.compact.ja-JP.Kyoko',
  cmn: 'com.apple.voice.compact.zh-CN.Tingting',
  vie: 'com.apple.voice.compact.vi-VN.Linh',
  kor: 'com.apple.voice.compact.ko-KR.Yuna',
  ara: 'com.apple.voice.compact.ar-001.Maged',
  ell: 'com.apple.voice.compact.el-GR.Melina',
  swe: 'com.apple.voice.compact.sv-SE.Alva',
  tur: 'com.apple.voice.compact.tr-TR.Yelda',
  // No browser has a Georgian voice; English rather than silence.
  geo: 'com.apple.voice.compact.en-GB.Daniel',
}

export default voices
